import { Component, h, Host, Prop, Listen, State } from '@stencil/core';
import {
  disableScrollBody,
  enableScrollBody
} from '../../../../../apps/website-frontend/src/ts/helpers/body-scroll.helper';
import { internalAnalyticsHelper } from '../../../../../shared/helpers/internal-analytics.helper';

@Component({
  tag: 'sidebar-right',
  styleUrl: 'sidebar-right.scss',
})
export class SidebarRight {
  @Prop() sidebarId: string;
  @State() isActive: boolean = false;
  @State() isHiding: boolean = false;

  @Listen('openSidebar', { target: 'document' })
  openHandler(event) {
    const { sidebarId } = event.detail;
    const isProfilePage = window.location.pathname.includes('account');
    if(sidebarId === this.sidebarId && !isProfilePage) {
      this.open();
    }
  }

  private open() {
    internalAnalyticsHelper('popUp', {
      element_name: 'otp_form_shown',
      value: 'shown',
    });

    this.isActive = true;
    disableScrollBody();
  }

  private close() {
    if(!this.isHiding) return;

    this.isHiding = false;
    this.isActive = false;
    enableScrollBody();
    document.dispatchEvent(new Event('onCloseSidebarRight'));
  }

  animateHide() {
    /**
     * Fallback for IE for close sidebar
     */
    if (typeof window.onanimationend === 'undefined') {
      this.isHiding = true;
      this.close();
      return;
    }

    if(!this.isActive) return;
    this.isHiding = true;
  }


  render() {
    return <Host class={this.isActive ? 'active' : ''}>
      <div class="popup-backdrop" onClick={() => this.animateHide()} />
      <div class={this.isHiding ? 'popup-scroll hiding' : 'popup-scroll'} onAnimationEnd={() => this.close()}>
        <div class="popup-close" onClick={() => this.animateHide()}/>
        <slot />
      </div>
    </Host>
  }
}
